import React, {useRef, useState, useEffect} from 'react'
import { Link, useLocation } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';

function ProfileMenu({ data }) {
    const location = useLocation();
    const swiperRef = useRef(null);

  const menuItems = [
    { to: '/profile', icon: 'user-circle', text: 'details' },
    { to: '/my-addresses', icon: 'home', text: 'addresses' },
    { to: '/my-orders', icon: 'cart-line', text: 'orders' },
    { to: '/my-wishlist', icon: 'like', text: 'wishlist' },
];

  // Find index of current path
  useEffect(() => {
    const currentIndex = menuItems.findIndex(item => location.pathname === item.to);
    if (swiperRef.current && currentIndex !== -1) {
        swiperRef.current.slideTo(currentIndex);
    }
}, [location.pathname]);

  return (
        <div className='bs-profile-menu lyt-profile__menu-wrap'>
            <h3 className='bs-profile-menu__profile-title'>Hi {data?.firstName},</h3>
            <ul className='bs-profile-menu__menu-list bs-profile-menu__menu-list--view-desktop'>
                {menuItems.map((item) => (
                    <li key={item.to} className="bs-profile-menu__menu-item">
                        <Link
                            to={item.to}
                            className={`mod-menu ${location.pathname === item.to ? 'mod-menu--active' : ''}`}
                        >
                            <span className={`icon icon-${item.icon} mod-menu__icon`}></span>
                            <span className="mod-menu__text">{item.text}</span>
                        </Link>
                    </li>
                ))}
            </ul>
            <Swiper
                slidesPerView={'auto'}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                spaceBetween={12}
                className="mySwiper bs-profile-menu__menu-list bs-profile-menu__menu-list--mobile"
            >
                {menuItems.map((item) => (
                    <SwiperSlide key={item.to} className="bs-profile-menu__menu-item">
                        <Link
                            to={item.to}
                            className={`mod-menu ${location.pathname === item.to ? 'mod-menu--active' : ''}`}
                        >
                            <span className={`icon icon-${item.icon} mod-menu__icon`}></span>
                            <span className="mod-menu__text">{item.text}</span>
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
  )
}

export default ProfileMenu